/**
 * intersection animation
 */
(() => {
  const observer = new IntersectionObserver((e) => {
    e.forEach((item) => {
      if (item.isIntersecting && item.intersectionRatio >= 0.5) {
        item.target.classList.add('section-active');
      }
    });
  }, {
    threshold: 0.5,
  });

  document.querySelectorAll('.custom-banner')
    .forEach((item) => {
      observer.observe(item);
    });
})();
